import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TrackingService } from './services/tracking.service';
import { LogType } from './helpers/enum';

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  title = 'MY Posventa';

  constructor(private router: Router,
    public oidcSecurityService: OidcSecurityService) {
  }



  hide_menu() {
    document.querySelectorAll('.navbar-collapse.show').forEach(function (el) {
      el.classList.remove('show');
    });
    document.querySelectorAll('.navbar-toggler').forEach(function (el) {
      el.classList.add('collapsed');
    });
  }

  ngOnInit() {

    const that = this;

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        that.hide_menu();
        return;
      }
      window.scrollTo(0, 0);
    });
  }

}
